import { render, staticRenderFns } from "./redirectUrlComponent.vue?vue&type=template&id=05913e2d&scoped=true"
import script from "./redirectUrlComponent.vue?vue&type=script&lang=js"
export * from "./redirectUrlComponent.vue?vue&type=script&lang=js"
import style0 from "./redirectUrlComponent.vue?vue&type=style&index=0&id=05913e2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05913e2d",
  null
  
)

export default component.exports